import i18n from 'i18next';

import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import loginEN from '@/i18next/en/login.json';
// import loginFR from '@/i18next/fr/login.json';
// import loginAR from '@/i18next/ar/login.json';

import requestsEN from '@/i18next/en/requests.json';
// import requestsFR from '@/i18next/fr/requests.json';
// import requestsAR from '@/i18next/ar/requests.json';

import appEN from '@/i18next/en/app.json';
// import appFR from '@/i18next/fr/app.json';
// import appAR from '@/i18next/ar/app.json';

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    fallbackLng: 'en',
    defaultNS: 'app',
    resources: {
      en: {
        login: loginEN,
        requests: requestsEN,
        app: appEN,
      },
      // fr: {
      //   login: loginFR,
      //   requests: requestsFR,
      //   app: appFR,
      // },
      // ar: {
      //   login: loginAR,
      //   requests: requestsAR,
      //   app: appAR,
      // },
    },
  });
